import { ReactNode } from 'react';

import { BackButtonRow } from 'shared/ui/back-button-row';
import { BackToTopButton } from 'shared/ui/buttons';

export type Props = {
  children: ReactNode;
};

export const SeeAllPage = ({ children }: Props) => {
  return (
    <div className="layout-context-compact container page">
      <BackButtonRow />
      <div className="row">{children}</div>
      <BackToTopButton />
    </div>
  );
};
